<nz-list-item [id]="'order-sampling-samplies-sidebar-cart-item-' + cartItem.item.id">
  <div nz-row>
    <div nz-col nzSpan="18" class="item-name">
      <app-cart-item-icon [cartItem]="cartItem" *ngIf="hasIcon()"></app-cart-item-icon>
      {{ cartItem.item.name }}</div>
    <div nz-col nzSpan="5" nzPush="1" class="item-price">
      <app-cart-item-price [cartItem]="cartItem"></app-cart-item-price>
    </div>
    <div nz-col nzSpan="24" *ngIf="isSamplingSupplyGroup">
      Qty: {{ cartItem.quantity }}
    </div>
  </div>
</nz-list-item>
